/**
** 专家登录界面--项目评估-进行中项目界面-详情界面
 */
<template>
  <div id="goingProDetail" class="jc-page">
    <div class="jc-panel jc-page-head">
      <span class="header-title">
        <el-page-header @back="returnPage" :content=headerTitle></el-page-header>
      </span>
      <div class="header-operation">
        <el-form ref="form" :model="form">
          <el-form-item>
            <el-input v-model="form.projectName" placeholder="项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-cascader clearable :options="checkup_category_tree_list" props.checkStrictly=true :props="defaultProps"
              v-model="form.type" placeholder="请选择父级" :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select clearable v-model="form.status" placeholder="完成状态">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button class="button" @click="getTableListInit">查询</el-button>
          <el-button class="button" @click="showDocDialog">项目文档</el-button>
          <el-button class="button" @click="multipleEvelItems">批量评估</el-button>
        </el-form>
      </div>
    </div>
    <div class="jc-table-container">
      <el-tabs ref="tabRef" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, i) in checkup_subject_list" :key="item.checkup_subject_id"
          :label="item.checkup_subject_name" :name="item.checkup_subject_id">
        </el-tab-pane>
      </el-tabs>
      <el-table height="calc(100% - 80px)" stripe border :data="datatable" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column type="index" label="序号" width="55"></el-table-column> -->
        <el-table-column label="类别" width="200" prop="checkup_category_name"></el-table-column>
        <el-table-column label="项目" width="150" prop="checkup_item_name"></el-table-column>
        <el-table-column label="评估内容" width="270" prop="checkup_item_evaluation_content"></el-table-column>
        <el-table-column label="标准分" width="100" prop="checkup_item_basic_score"></el-table-column>
        <el-table-column label="扣分" width="100" prop="checkup_item_deduct_score"></el-table-column>
        <el-table-column label="实际得分" width="100" prop="checkup_item_real_score"></el-table-column>
        <el-table-column label="完成时间" width="120" prop="checkup_item_score_point"></el-table-column>
        <el-table-column label="属地部门" width="150" prop="checkup_department_name"></el-table-column>
        <el-table-column label="考察层级" width="150" prop="investigation_level_name_string"></el-table-column>
        <el-table-column label="状态" prop="checkup_item_status_name">
          <template slot-scope="scope">
            <span style="color:#EF8C2B;" v-if="scope.row.checkup_item_status_name == '未评估'">{{
              scope.row.checkup_item_status_name }}</span>
            <span style="color:#ee22cd;" v-if="scope.row.checkup_item_status_name == '正评估'">{{
              scope.row.checkup_item_status_name }}</span>
            <span style="color:#0C76FE;" v-if="scope.row.checkup_item_status_name == '已评估'">{{
              scope.row.checkup_item_status_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEval(scope.row)" type="text" size="small">评估</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 项目评估 -->
    <el-dialog title="检查条目评估" :visible.sync="dialogVisible" class="dialog" :before-close="cancelProjectEvel"  width="75%">
      <div class="check-item-evel-info">
        <el-row>
          <el-col :span="24">
            <h3>{{ formInline.checkup_category_name }}</h3>
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8">检查项目：{{ formInline.checkup_item_no }}</el-col>
          <el-col :span="8"
            v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_basic_score_switch == '1'">标准分：{{
              formInline.checkup_item_basic_score }}</el-col>
          <el-col :span="8">完成时间：{{ formInline.action_period_name }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;">
          <el-col :span="8">属地部门：{{ formInline.checkup_department_name }}</el-col>
          <el-col :span="8">考察层级：{{ formInline.investigation_level_name_string }}</el-col>
          <el-col :span="8">当前状态：{{ formInline.checkup_item_status_info ?
            formInline.checkup_item_status_info.checkup_item_status_name : '' }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_evaluation_content_switch == '1'">
          <el-col :span="24">评估内容：{{ formInline.checkup_item_evaluation_content }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_score_point_switch == '1'">
          <el-col :span="24">评分标准：{{ formInline.checkup_item_score_point }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_require_switch == '1'">
          <el-col :span="24">标准化要求：{{ formInline.checkup_item_standard_require }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_point_switch == '1'">
          <el-col :span="24">企业达标标准：{{ formInline.checkup_item_standard_point }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_method_switch == '1'">
          <el-col :span="24">评审方法：{{ formInline.checkup_item_review_method }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_criteria_no_but_switch == '1'">
          <el-col :span="24">评审标准-否决项：{{ formInline.checkup_item_review_criteria_no_but }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_review_criteria_deduction_switch == '1'">
          <el-col :span="24">评审标准-扣分项：{{ formInline.checkup_item_review_criteria_deduction }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_review_number_switch == '1'">
          <el-col :span="24">标准化评审规范号：{{ formInline.checkup_item_standard_review_number }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_standard_review_content_switch == '1'">
          <el-col :span="24">标准化评审内容：{{ formInline.checkup_item_standard_review_content }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_content_switch == '1'">
          <el-col :span="24">检查内容/考核要求: {{ formInline.checkup_item_inspection_content }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_basis_switch == '1'">
          <el-col :span="24">检查依据：{{ formInline.checkup_item_inspection_basis }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_inspection_method_switch == '0'">
          <el-col :span="24">检查方法：{{ formInline.checkup_item_inspection_method }}</el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_case_image_switch == '0'">
          <el-col :span="24">案例照片：
            <img class="question-describe-image" v-for="image in formInline.checkup_item_case_image_list"
              :src="image.thumb">
          </el-col>
        </el-row>
        <el-row style="margin-top:5px;"
          v-if="formInline.checkup_item_switch_info && formInline.checkup_item_switch_info.checkup_item_complete_time_limit_switch == '0'">
          <el-col :span="24">完成时限：{{ formInline.checkup_item_complete_time_limit }}</el-col>
        </el-row>
      </div>
      <div class="jc-check-item-evel-section" v-for="inspection in formInline.checkup_item_inspection_point_content_list"
        :key="inspection.checkup_subject_item_evaluation_origin_id">
        <h4 style="text-align:left;">{{ inspection.evaluation_method_type_info.evaluation_method_type_name }}</h4>
        <div class="jc-check-item-evel-section-header">
          <div>支持材料</div>
          <div>{{ inspection.checkup_item_inspection_point }}</div>
        </div>
        <div class="question-describe"
          v-if="inspection.evaluation_method_type_info.evaluation_method_type_name == '书面材料' || inspection.evaluation_method_type_info.evaluation_method_type_name == '实地考察'">
          <el-table style="margin-top:10px;" :data="inspection.expert_evaluation_list" height="450" border>
            <el-table-column width="100" label="导向">
              <template slot-scope="scope">
                <el-select v-model="newQuestionForm.is_positive"  @change="selectIsPositive = true"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                  <el-option label="正面" value="1">
                  </el-option>
                  <el-option label="负面" value="0">
                  </el-option>
                </el-select>
                <template v-else>
                  {{ scope.row.is_positive == "1" ? "正面" : "负面" }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="问题描述"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_problem_description_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newQuestionForm.checkup_evaluation_problem_description" :disabled="newQuestionForm.is_positive === '1' && selectIsPositive"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name"></el-input>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span> {{ scope.row.checkup_evaluation_problem_description }}</span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;"> {{ scope.row.checkup_evaluation_problem_description }}
                    </span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="问题分类" width="150"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_project_type_switch == 1">
              <template slot-scope="scope">
                <el-select
                  v-model="newQuestionForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                  <el-option v-for="item in checkup_evaluation_project_type_list"
                    :key="item.checkup_evaluation_project_type_id" :label="item.checkup_evaluation_project_type_name"
                    :value="item.checkup_evaluation_project_type_id">
                  </el-option>
                </el-select>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span>{{ scope.row.checkup_evaluation_project_type_info.checkup_evaluation_project_type_name }}
                    </span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;">{{
                      scope.row.checkup_evaluation_project_type_info.checkup_evaluation_project_type_name }}
                    </span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="照片" width="100"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_image_switch == 1">
              <template slot-scope="scope">
                <template
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                  <el-upload :data="imageUploadParam" ref="uploadImageRef" :action="UploadImageUrl()" :file-list="imagList" 
                    :on-success="questionImageUploadSuccess">
                    <div>
                      <el-button size="small" icon="el-icon-plus"></el-button>
                    </div>
                  </el-upload>
                </template>
                <template v-else>
                  <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_image_list" :key="image.source"
                    :content="image.path">
                    <img class="question-describe-image" :src="image.thumb"
                      @click="showImage(image, scope.row.checkup_subject_item_evaluation_image_list)">
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="文档" width="200"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_file_switch == 1">
              <template slot-scope="scope">
                <template
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                  <el-upload :data="fileUploadParam" ref="uploadQuestion" action="#" :file-list="fileList" :limit="100"
                    :http-request="Execute_File_Question" :auto-upload="false" :on-change="upload_change"
                    :on-remove="upload_remove">
                    <div>
                      <el-button size="small" icon="el-icon-plus"></el-button>
                    </div>
                  </el-upload>
                  <el-progress :percentage="nowRate" :text-inside="true" status="success" v-if="upload_List.length != 0"
                    :show-text="false" style="margin-bottom: 5px;"></el-progress>
                  <el-button size="small" @click="uploadFileQuestion" v-if="upload_List.length != 0">上传</el-button>
                </template>
                <template v-else>
                  <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_file_list" :key="image.url"
                    :content="image.file_name">
                    <span class="question-describe-file"
                      @click="showFile(image, scope.row.checkup_subject_item_evaluation_file_list)">
                      {{ image.file_name }}
                    </span>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="整改建议"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_suggest_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newQuestionForm.checkup_evaluation_improve_suggest" :disabled="newQuestionForm.is_positive === '1' && selectIsPositive"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name"></el-input>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span>{{ scope.row.checkup_evaluation_improve_suggest }}</span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;">{{ scope.row.checkup_evaluation_improve_suggest }}</span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="整改时限"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_time_limit_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newQuestionForm.checkup_item_evaluation_improve_time_limit"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name"></el-input>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span>{{ scope.row.checkup_item_evaluation_improve_time_limit }}</span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;">
                      {{ scope.row.checkup_item_evaluation_improve_time_limit }}</span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="检查结果"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_inspection_result_switch == 1">
              <template slot-scope="scope">
                <el-input  type="textarea" v-model="newQuestionForm.checkup_item_evaluation_inspection_result"  :disabled="newQuestionForm.is_positive === '0' && selectIsPositive"
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name"></el-input>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span>{{ scope.row.checkup_item_evaluation_inspection_result }}</span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;">{{ scope.row.checkup_item_evaluation_inspection_result }}</span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <template
                  v-if="scope.$index == modifyQuestionIndex && modifyQuestionType == inspection.evaluation_method_type_info.evaluation_method_type_name">
                  <template v-if="scope.row.is_positive != '1'">
                    <el-button @click="addNewQuestion(inspection)" type="text" size="small">保存</el-button>
                    <el-button @click="deleteNewQuestion(inspection.expert_evaluation_list)" type="text"
                      size="small">删除</el-button>
                  </template>
                  <template v-else>
                    <el-button style="font-weight:bold;" @click="addNewQuestion(inspection)" type="text"
                      size="small">保存</el-button>
                    <el-button style="font-weight:bold;" @click="deleteNewQuestion(inspection.expert_evaluation_list)"
                      type="text" size="small">删除</el-button>
                  </template>
                </template>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <el-button
                      @click="modifyQuestion(inspection, scope.$index, inspection.evaluation_method_type_info.evaluation_method_type_name)"
                      type="text" size="small">修改</el-button>
                    <el-button @click="deleteQuestion(inspection.expert_evaluation_list, scope.$index)" type="text"
                      size="small">删除</el-button>
                  </template>
                  <template v-else>
                    <el-button style="font-weight:bold;"
                      @click="modifyQuestion(inspection, scope.$index, inspection.evaluation_method_type_info.evaluation_method_type_name)"
                      type="text" size="small">修改</el-button>
                    <el-button style="font-weight:bold;"
                      @click="deleteQuestion(inspection.expert_evaluation_list, scope.$index)" type="text"
                      size="small">删除</el-button>
                  </template>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-button style="margin-top:10px;" icon="el-icon-plus"
            @click="addQuestion(inspection, inspection.evaluation_method_type_info.evaluation_method_type_name)">添加问题</el-button>
        </div>

        <div class="object-describe" v-if="inspection.evaluation_method_type_info.evaluation_method_type_name == '现场询问'">
          <el-table style="margin-top:10px;" :data="inspection.expert_evaluation_list" height="450" border>
            <el-table-column width="100" label="导向">
              <template slot-scope="scope">
                <el-select v-model="newObjectForm.is_positive"  @change="selectIsPositive = true" v-if="scope.$index == modifyObjectIndex">
                  <el-option label="正面" value="1">
                  </el-option>
                  <el-option label="负面" value="0">
                  </el-option>
                </el-select>
                <template v-else>
                  {{ scope.row.is_positive == "1" ? "正面" : "负面" }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="检查对象">
              <template slot-scope="scope">
                <el-input v-model="newObjectForm.checkup_object_info.checkup_object_name"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  {{ scope.row.checkup_object_info.checkup_object_name }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="检查对象类型">
              <template slot-scope="scope">
                <el-select v-model="newObjectForm.checkup_object_info.checkup_object_type_info.checkup_object_type_id"
                  v-if="scope.$index == modifyObjectIndex">
                  <el-option v-for="item in checkup_object_type_list" :key="item.checkup_object_type_id"
                    :label="item.checkup_object_type_name" :value="item.checkup_object_type_id">
                  </el-option>
                </el-select>
                <template v-else>
                  {{ scope.row.checkup_object_info.checkup_object_type_info.checkup_object_type_name }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="检查对象地址">
              <template slot-scope="scope">
                <el-input v-model="newObjectForm.checkup_object_info.checkup_object_address"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  {{ scope.row.checkup_object_info.checkup_object_address }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="问题描述"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_problem_description_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newObjectForm.checkup_evaluation_problem_description" :disabled="newObjectForm.is_positive === '1' && selectIsPositive"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  {{ scope.row.checkup_evaluation_problem_description }}
                </template>
              </template>
            </el-table-column>
            <el-table-column label="问题分类" width="200"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_project_type_switch == 1">
              <template slot-scope="scope">
                <el-select v-model="newObjectForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id"
                  v-if="scope.$index == modifyObjectIndex">
                  <el-option v-for="item in checkup_evaluation_project_type_list"
                    :key="item.checkup_evaluation_project_type_id" :label="item.checkup_evaluation_project_type_name"
                    :value="item.checkup_evaluation_project_type_id">
                  </el-option>
                </el-select>
                <template v-else>
                  {{ scope.row.checkup_evaluation_project_type_info.checkup_evaluation_project_type_name }}
                </template>
              </template>
            </el-table-column>
            <el-table-column label="照片" width="100"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_image_switch == 1">
              <template slot-scope="scope">
                <template v-if="scope.$index == modifyObjectIndex">
                  <el-upload :data="imageUploadParam" ref="objectUploadImageRef" :action="UploadImageUrl()" :file-list="imagList" 
                    :on-success="objectImageUploadSuccess">
                    <div>
                      <el-button size="small" icon="el-icon-plus"></el-button>
                    </div>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible111">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </template>
                <template v-else>
                  <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_image_list" :key="image.source"
                    :content="image.path">
                    <img class="question-describe-image" :src="image.thumb"
                      @click="showImage(image, scope.row.checkup_subject_item_evaluation_image_list)">
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="文档" width="100"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_file_switch == 1">
              <template slot-scope="scope">
                <template v-if="scope.$index == modifyObjectIndex">
                  <el-upload :data="fileUploadParam" ref="uploadObject" action="#" :file-list="fileList" :limit="100"
                    :http-request="Execute_File_Object" :auto-upload="false" :on-change="upload_change"
                    :on-remove="upload_remove">
                    <div>
                      <el-button size="small" icon="el-icon-plus"></el-button>
                    </div>
                  </el-upload>
                  <el-progress :percentage="nowRate" :text-inside="true" status="success" v-if="upload_List.length != 0"
                    :show-text="false" style="margin-bottom: 5px;"></el-progress>
                  <el-button size="small" @click="uploadFileObject" v-if="upload_List.length != 0">上传</el-button>
                </template>
                <template v-else>
                  <el-tooltip v-for="image in scope.row.checkup_subject_item_evaluation_file_list" :key="image.url"
                    :content="image.file_name">
                    <span class="question-describe-file"
                      @click="showFile(image, scope.row.checkup_subject_item_evaluation_file_list)">
                      {{ image.file_name }}
                    </span>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="整改建议"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_suggest_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newObjectForm.checkup_evaluation_improve_suggest" :disabled="newObjectForm.is_positive === '1' && selectIsPositive"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  {{ scope.row.checkup_evaluation_improve_suggest }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="整改时限"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_improve_time_limit_switch == 1">
              <template slot-scope="scope">
                <el-input v-model="newObjectForm.checkup_item_evaluation_improve_time_limit"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  {{ scope.row.checkup_item_evaluation_improve_time_limit }}
                </template>
              </template>
            </el-table-column>
            <el-table-column width="200" label="检查结果"
              v-if="formInline.checkup_item_evaluation_switch_info.checkup_item_evaluation_inspection_result_switch == 1">
              <template slot-scope="scope">
                <el-input  type="textarea" v-model="newObjectForm.checkup_item_evaluation_inspection_result"  :disabled="newObjectForm.is_positive === '0' && selectIsPositive"
                  v-if="scope.$index == modifyObjectIndex"></el-input>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <span>{{ scope.row.checkup_item_evaluation_inspection_result }}</span>
                  </template>
                  <template v-else>
                    <span style="font-weight:bold;">{{ scope.row.checkup_item_evaluation_inspection_result }}</span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <template v-if="scope.$index == modifyObjectIndex">
                  <template v-if="scope.row.is_positive != '1'">
                    <el-button @click="addNewObject(inspection)" type="text" size="small">保存</el-button>
                    <el-button @click="deleteNewObject(inspection.expert_evaluation_list)" type="text"
                      size="small">删除</el-button>
                  </template>
                  <template v-else>
                    <el-button style="font-weight:bold;" @click="addNewObject(inspection)" type="text"
                      size="small">保存</el-button>
                    <el-button style="font-weight:bold;" @click="deleteNewObject(inspection.expert_evaluation_list)"
                      type="text" size="small">删除</el-button>
                  </template>
                </template>
                <template v-else>
                  <template v-if="scope.row.is_positive != '1'">
                    <el-button @click="modifyObject(inspection, scope.$index)" type="text" size="small">修改</el-button>
                    <el-button @click="deleteObject(inspection.expert_evaluation_list, scope.$index)" type="text"
                      size="small">删除</el-button>
                  </template>
                  <template v-else>
                    <el-button style="font-weight:bold;" @click="modifyObject(inspection, scope.$index)" type="text"
                      size="small">修改</el-button>
                    <el-button style="font-weight:bold;"
                      @click="deleteObject(inspection.expert_evaluation_list, scope.$index)" type="text"
                      size="small">删除</el-button>
                  </template>

                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-button style="margin-top:10px;" icon="el-icon-plus" @click="addObject(inspection)">添加问题</el-button>
        </div>

      </div>
      <div class="project-evel" style="text-align:left;" v-show="evaluationShow">
        <h4 style="text-align:left;">项目评估</h4>
        <el-form ref="projectEvelRef" :model="projectEvelForm" :rules="projectEvelFormRules">
          <el-form-item :label="scoreFlag" prop="score"
            v-if="projectEvelForm.score_switch != '1' || projectEvelForm.checkup_item_bcadd_bcsub != '0'">
            <el-input-number style="height:40px;" v-model="projectEvelForm.score" controls-position="right" :min="0"
              :max="maxnum"></el-input-number>
          </el-form-item>
          <el-form-item label="是否重点问题" prop="key_issues" v-if="projectEvelForm.key_issues_switch == 1">
            <el-select v-model="projectEvelForm.key_issues" controls-position="right" :min="0" :max="100">
              <el-option v-for="item in checkup_item_evaluation_key_issues_list" :key="item.id" :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button style="margin-top:10px;">不涉及项</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelProjectEvel">返 回</el-button>
        <el-button type="primary" @click="okProjectEvel">完成评估</el-button>
      </span>
    </el-dialog>
    <!-- 项目文档 -->
    <el-dialog title="项目文档" :visible.sync="dialogVisibleDoc" class="docDialog">
      <el-table :data="projectDocumentData" stripe style="width: 100%">
        <el-table-column prop="checkup_project_file_url_info.file_name" label="文档名称"></el-table-column>
        <el-table-column prop="checkup_project_file_category_info.checkup_project_file_category_name"
          label="文档分类"></el-table-column>
        <el-table-column prop="create_date" label="时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <a style="color:#409EFF;font-size:12px;text-decoration:none;" target="view_window"
              :href="scope.row.checkup_project_file_url_info.url">查看</a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="" :visible.sync="showImageDialog">
      <img :src="showImageData.source" style="width:80%;">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteImage">删 除</el-button>
        <el-button type="primary" @click="showImageDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="showFileDialog">
      <div>请选择要文件：{{ showFileData.file_name }}，进行的操作</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadFile">下 载</el-button>
        <el-button type="primary" @click="deleteFile">删 除</el-button>
        <el-button type="primary" @click="showFileDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { eventBus } from '../../../eventbus/index'
import axios from 'axios';
import {
  getCheckupSubjectList,
  getCheckupSubjectItemList,
  getCheckupSubjectItemInfo,
  getCheckupEvaluationProjectTypeList,
  getCheckupObjectTypeList,
  notInvolvedCheckupSubjectItemEvaluation,
  finishCheckupSubjectItemEvaluation,
  saveCheckupSubjectItemEvaluationInfo,
  getCheckupProjectFileCategoryList,
  checkItemEvaluationDel,
  saveCheckItemScore
} from '@/apis/expert'
import {
  getCheckupProjectFileList,
  getCheckupCategoryTreeList
} from '@/apis/projects'
import { getToken, getUserId, getIdentityType } from '@/utils/auth'
export default {
  name: "GoingProDetail",
  data() {
    return {
      rate: 0,
      nowRate: 0,
      rateNow: 0,
      imagList: [],
      fileList: [], //深拷贝，判断重名及第一步时的文件信息展示
      upload_List: [], //上传的file,
      notifyPromise: Promise.resolve(), // 解决Notification组件的高度塌陷问题
      scoreFlag: "扣分",
      maxnum: 12,
      dialogVisible111: false,
      multipleSelection: [],
      checkup_subject_item_id: '',
      checkup_subject_id: '',
      selectIsPositive: false,
      projectEvelForm: {
        score_switch: '0',
        score: '',
        key_issues: '',
        key_issues_switch: '0',
      },
      projectEvelFormRules: {
        score: [
          { required: true, message: "请输入扣分", trigger: 'blur' }
        ]
      },
      checkup_item_evaluation_key_issues_list: [{ id: '0', name: '否' }, { id: '1', name: '是' }],
      evaluationShow: false,
      headerTitle: "项目详情",
      activeName: '0',
      form: {
        projectName: "",
        type: "",
        status: ""
      }, // 头部表单内容
      typeOptions: [
        {
          value: '1',
          label: '1'
        }
      ],
      statusOptions: [
        {
          value: '40001',
          label: '未评估'
        }, {
          value: '40002',
          label: '正评估'
        }
      ], // 完成状态
      tabPane: [],// 详情界面-检查表表内容
      dialogVisible: false, // 项目评估对话框显示标识
      dialogVisibleDoc: false, // 项目文档对话框显示标识
      formInline: {},// 对话框中头部form表单
      tableDataDoc: [
        {
          docName: "文档A",
          docClass: "15.1.1",
          dateTime: "2021-10-01"
        }
      ], // "项目文档"对话框表格数据
      materEval: [
        {
          describe: "",
          classify: "",
          picture: [{ name: '', url: '' }],
          file: [{ name: '', url: '' }],
          propose: ""
        }
      ], // dialog对话框中“资料评估”表格数据
      materScene: [
        {
          checkObj: "高新一小",
          problemDes: "校园安全体制有缺失",
          problemClass: "--",
          picture: [{ name: '', url: '' }],
          file: [{ name: '', url: '' }],
          propose: "--"
        }
      ], // dialog对话框中“现场评估”表格数据
      classifyOptions: [
        {
          value: "1",
          label: "资质证照"
        }
      ], // dialog对话框中“资料评估”表格数据-问题分类
      imageUrl: "",// 点击“照片”上传
      dialogImgVisible: false,
      // evalImgList:[{name:'',url:''}], // 资料评估-照片上传
      // evalFileList:[{name:'',url:''}], // 资料评估-文件上传
      showBtnFile: true, // 资料评估-文件上传标识
      noneBtnFile: false, // 资料评估-文件上传标识
      limitFile: 1, //上传文件的最大数量
      showBtnImg: true, // 资料评估-图片上传标识
      noneBtnImg: false, // 资料评估-图片上传标识
      limitImg: 3, // 上传图片的最大数量
      projectMater: {
        score: ""
      }, // 项目评估-扣分
      rules: {
        score: [
          { required: true, message: '扣分不能为空' },
          { type: 'number', message: '必须为数值' }
        ]
      },
      checkup_project_id: '',
      checkup_subject_list: [],
      datatable: [],

      checkup_evaluation_project_type_list: [],
      imageUploadParam: {
        device_type: 20,
        user_id: getUserId(),
        token: getToken(),
        identity_type: getIdentityType(),
        jsonText: JSON.stringify({ "image_type_key": "checkup_subject_item_expert_evaluation_image" })
      },
      fileUploadParam: {
        device_type: 20,
        user_id: getUserId(),
        token: getToken(),
        identity_type: getIdentityType(),
        jsonText: JSON.stringify({ "file_type_key": "checkup_subject_item_expert_evaluation_file" })
      },
      modifyQuestionType: '',
      modifyQuestionIndex: -1,
      questionUploadImages: [],
      questionUploadFiles: [],
      newQuestionForm: {
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: ''
      },

      modifyObjectIndex: -1,
      objectUploadImages: [],
      objectUploadFiles: [],
      newObjectForm: {
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: {
          "checkup_object_name": "",
          "checkup_object_address": "",
          "checkup_object_type_info": {
            "checkup_object_type_id": "",
            "checkup_object_type_name": ""
          }
        },
      },
      checkup_object_type_list: [],
      projectDocumentData: [],
      uploadUrl: process.env.BASE_API,
      showImageDialog: false,
      showImageData: { thumb: '' },
      imageList: [],
      showFileDialog: false,
      showFileData: {},
      fileList: [],
      checkup_category_tree_list: [],
      defaultProps: {
        label: "checkup_category_name",
        value: "checkup_category_id",
        checkStrictly: true
      },
    }
  },
  mounted() {
    eventBus.$on('toProjectEval', data => {

      this.headerTitle = data.title;

    });
    this.selectIsPositive = false
    this.checkup_project_id = this.$route.params.id
    this.loadBasicData()
  },
  created() {
  },

  methods: {
    async uploadFileObject() {
      const that = this
      var file = this.upload_List[0].raw
      var file_size = file.size;                      //文件总大小
      if (file_size >= 62914560) {
        this.$refs.uploadObject[0].submit();
      } else {
        var form = new FormData();
        for (var key in this.fileUploadParam) {
          form.append(key, this.fileUploadParam[key]);
        }
        form.append("file", file);    //数据
        await axios({
          url: this.uploadUrl + "/Base/Tools/editFile",
          method: "POST",
          data: form,
          onUploadProgress: function (progressEvent) {
            const complete = parseInt((progressEvent.loaded / progressEvent.total * 100 | 0)) * 0.9
            that.nowRate = complete
          }
        }).then(res => {
          if (res.data.status == "1") {
            this.nowRate = 100
            this.newObjectForm.checkup_subject_item_evaluation_file_list.push({ ...res.data.data })
            this.$message.success(`上传成功`)
          } else {
            this.$message.error(`Error`)
          }
        })
      }
    },
    async Execute_File_Object() {
      const that = this
      var file = this.upload_List[0].raw
      var file_name = file.name;                      //文件名
      var file_size = file.size;                      //文件总大小
      var succeed = 0;                                //请求成功次数
      var shardSize = 62914560;                       //30M分片大小单位字节 记得去php配置调整文件大小
      var shardCount = Math.ceil(file_size / shardSize);//总片数
      for (var i = 0; i < shardCount; i++) {
        var start = i * shardSize;                  // 计算每一片数据的起始与结束位置              
        var end = Math.min(file_size, start + shardSize);
        var form = new FormData();
        for (var key in this.fileUploadParam) {
          form.append(key, this.fileUploadParam[key]);
        }
        form.append("data", file.slice(start, end));    //切片数据
        form.append("file_name", file_name);            //文件名
        form.append("total", shardCount);               // 总片数
        form.append("index", i + 1);                    // 当前是第几片
        form.append("act", "upload");                    // 当前是第几片
        form.append("file_type_key", "checkup_project_file");                    // 当前是第几片
        await axios({
          url: this.uploadUrl + "/Base/Tools/bigFileUpload",
          method: "POST",
          data: form,
          onUploadProgress: function (progressEvent) {
            const complete = parseInt((progressEvent.loaded / progressEvent.total * 100 | 0))
            that.nowRate = (complete * progressEvent.total / shardSize + that.rateNow) * 0.9;
          }
        }).then(res => {
          this.rateNow = this.nowRate;
          if (res.data.status == "0") {
            this.$message.error(res.msg)
            this.$refs.uploadQuestion[0].clearFiles()
          } else {
            succeed++;
            if (succeed == shardCount) {
              var tempForm = new FormData();
              for (var key in this.fileUploadParam) {
                tempForm.append(key, this.fileUploadParam[key]);
              }
              tempForm.append("total", shardCount);               // 总片数
              tempForm.append("file_name", file_name);
              tempForm.append("act", "join");
              axios({
                url: this.uploadUrl + "/Base/Tools/bigFileUpload",
                method: "POST",
                data: tempForm,
              }).then(res => {
                if (res.data.status == "1") {
                  this.nowRate = 100
                  this.rateNow = 0
                  this.newObjectForm.checkup_subject_item_evaluation_file_list.push({ ...res.data.data })
                  this.$message.success(`上传成功`)
                } else {
                  this.$message.error(`Error`)
                }
              });
            }
          }
        }).catch(res => {
          this.$message.error(`Error`)
        })
      }
    },
    upload_change(file, fileList) {
      this.fileList = JSON.parse(JSON.stringify(fileList));
      this.upload_List.pop();
      this.upload_List.push(file);
      this.nowRate = 0
    },
    upload_remove(file, fileList) {
      this.fileList = JSON.parse(JSON.stringify(fileList));
      this.upload_List.forEach((item, index) => {
        if (item.name == file.name) {
          this.upload_List.splice(index, 1);
          this.nowRate = 0
        }
      });
    },
    async uploadFileQuestion() {
      const that = this
      var file = this.upload_List[0].raw
      var file_size = file.size;                      //文件总大小
      if (file_size >= 62914560) {
        this.$refs.uploadQuestion[0].submit();
      } else {
        var form = new FormData();
        for (var key in this.fileUploadParam) {
          form.append(key, this.fileUploadParam[key]);
        }
        form.append("file", file);    //数据
        await axios({
          url: this.uploadUrl + "/Base/Tools/editFile",
          method: "POST",
          data: form,
          onUploadProgress: function (progressEvent) {
            const complete = parseInt((progressEvent.loaded / progressEvent.total * 100 | 0)) * 0.9
            that.nowRate = complete
          }
        }).then(res => {
          if (res.data.status == "1") {
            this.nowRate = 100
            this.newQuestionForm.checkup_subject_item_evaluation_file_list.push({ ...res.data.data })
            this.$message.success(`上传成功`)
          } else {
            this.$message.error(`Error`)
          }
        })
      }
    },
    async Execute_File_Question() {
      const that = this
      var file = this.upload_List[0].raw
      var file_name = file.name;                      //文件名
      var file_size = file.size;                      //文件总大小
      var succeed = 0;                                //请求成功次数
      var shardSize = 62914560;                       //30M分片大小单位字节 记得去php配置调整文件大小
      var shardCount = Math.ceil(file_size / shardSize);//总片数
      for (var i = 0; i < shardCount; i++) {
        var start = i * shardSize;                  // 计算每一片数据的起始与结束位置              
        var end = Math.min(file_size, start + shardSize);
        var form = new FormData();
        for (var key in this.fileUploadParam) {
          form.append(key, this.fileUploadParam[key]);
        }
        form.append("data", file.slice(start, end));    //切片数据
        form.append("file_name", file_name);            //文件名
        form.append("total", shardCount);               // 总片数
        form.append("index", i + 1);                    // 当前是第几片
        form.append("act", "upload");                    // 当前是第几片
        form.append("file_type_key", "checkup_project_file");
        await axios({
          url: this.uploadUrl + "/Base/Tools/bigFileUpload",
          method: "POST",
          data: form,
          onUploadProgress: function (progressEvent) {
            const complete = parseInt((progressEvent.loaded / progressEvent.total * 100 | 0))
            that.nowRate = (complete * progressEvent.total / shardSize + that.rateNow) * 0.9;
          }
        }).then(res => {
          this.rateNow = this.nowRate
          console.log(this.rateNow);
          if (res.data.status == "0") {
            this.$message.error(res.msg)
            this.$refs.uploadQuestion[0].clearFiles()
          } else {
            succeed++;
            if (succeed == shardCount) {
              var tempForm = new FormData();
              for (var key in this.fileUploadParam) {
                tempForm.append(key, this.fileUploadParam[key]);
              }
              tempForm.append("total", shardCount);               // 总片数
              tempForm.append("file_name", file_name);
              tempForm.append("act", "join");
              axios({
                url: this.uploadUrl + "/Base/Tools/bigFileUpload",
                method: "POST",
                data: tempForm,
              }).then(res => {
                console.log(res)
                if (res.data.status == "1") {
                  this.nowRate = 100
                  this.rateNow = 0
                  this.newQuestionForm.checkup_subject_item_evaluation_file_list.push({ ...res.data.data })
                  this.$message.success(`上传成功`)
                } else {
                  this.$message.error(`Error`)
                }
              });
            }
          }
        }).catch(res => {
          this.$message.error(`Error`)
        })
      }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = [...rows]
    },
    multipleEvelItems() {
      if (!(this.multipleSelection && this.multipleSelection.length > 0)) {
        this.$message.error('请选择待评估的条目');
        return
      }
      this.$confirm('确定完成评估?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multipleSelection.forEach(x => {
          finishCheckupSubjectItemEvaluation({
            "checkup_subject_id": this.activeName,
            "checkup_subject_item_id": x.checkup_subject_item_id
          }).then(res => {

            if (res.data.status == '0') {
              this.$message.error(res.data.msg)
            } else if (res.data.status == '1') {
              this.$message.info("完成评估")
            }
            this.loadBasicData()
          })
        })

      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible111 = true
    },
    deleteFile() {
      let index = this.fileList.findIndex(x => x.url == this.showFileData.url)
      this.fileList.splice(index, 1)
      this.showFileDialog = false
    },
    deleteImage() {
      let index = this.imageList.findIndex(x => x.thumb == this.showImageData.thumb)
      this.imageList.splice(index, 1)
      this.showImageDialog = false
    },
    showImage(image, images) {
      this.showImageDialog = true
      this.showImageData = image
      this.imageList = images
    },
    downloadFile() {
      window.open(this.showFileData.url)
    },
    // deleteFile(){
    //     let index = this.fileList.findIndex(x=>x.url == this.showFileData.url)
    //     this.fileList.splice(index, 1)
    //     this.showFileDialog = false
    // },
    showFile(file, files) {
      this.showFileDialog = true
      this.showFileData = file
    },
    UploadFileUrl: function () {
      return this.uploadUrl + "/Base/Tools/editFile";
    },
    UploadImageUrl: function () {
      return this.uploadUrl + "/Base/Tools/editImage";
    },
    handleCheckDoc(row) {

    },
    cancelProjectEvel() {
      saveCheckItemScore({
        checkup_subject_id: this.checkup_subject_id,
        checkup_subject_item_id: this.checkup_subject_item_id,
        checkup_item_deduct_score: this.projectEvelForm.score,
        checkup_item_evaluation_key_issues: this.projectEvelForm.key_issues,
      }).then(res => {
        if (res.data.status == "1") {
          this.$message.success("保存成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
      this.dialogVisible = false
      this.modifyQuestionIndex = -1
      this.modifyQuestionType = ""
      this.modifyObjectIndex = -1
    },
    okProjectEvel() {
      this.$confirm('确定完成评估?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        finishCheckupSubjectItemEvaluation({
          "checkup_subject_id": this.checkup_subject_id,
          "checkup_subject_item_id": this.checkup_subject_item_id
        }).then(res => {

          if (res.data.status == '0') {
            this.$message.error(res.data.msg)
          } else if (res.data.status == '1') {
            this.$message.error("完成评估")
          }
          this.cancelProjectEvel()
          this.loadData()
        })
      })

    },
    saveProjectEvel() {
      this.$refs.projectEvelRef.validate(valid => {
        if (valid) {
          let expert_evaluation_list = []
          this.formInline.checkup_item_inspection_point_content_list.forEach(x => {
            x.expert_evaluation_list.forEach(y => {
              let obj = {
                "expert_evaluation_id": "0",
                "checkup_subject_item_evaluation_origin_id": x.checkup_subject_item_evaluation_origin_id,
                "checkup_object_name": "",
                "checkup_object_address": "",
                "checkup_object_type_id": "",
                "checkup_evaluation_project_type_id": "",
                "checkup_evaluation_problem_description": "",
                "checkup_evaluation_improve_suggest": "",
                "checkup_item_evaluation_improve_time_limit": "",
                "checkup_item_evaluation_inspection_result": "",
                "checkup_subject_item_evaluation_image_list": [],
                "checkup_subject_item_evaluation_file_list": [],
                is_positive: 0
              }
              if (y.checkup_evaluation_project_type_info &&
                y.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id &&
                y.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id.length > 0) {
                obj.checkup_evaluation_project_type_id = y.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id
              }
              obj.checkup_evaluation_problem_description = y.checkup_evaluation_problem_description ? y.checkup_evaluation_problem_description : ""
              obj.checkup_evaluation_improve_suggest = y.checkup_evaluation_improve_suggest ? y.checkup_evaluation_improve_suggest : ""
              obj.checkup_item_evaluation_improve_time_limit = y.checkup_item_evaluation_improve_time_limit ? y.checkup_item_evaluation_improve_time_limit : ""
              obj.checkup_item_evaluation_inspection_result = y.checkup_item_evaluation_inspection_result ? y.checkup_item_evaluation_inspection_result : ""
              y.checkup_subject_item_evaluation_image_list.forEach(z => {
                obj.checkup_subject_item_evaluation_image_list.push(z.path)
              })
              y.checkup_subject_item_evaluation_file_list.forEach(z => {
                obj.checkup_subject_item_evaluation_file_list.push(z.path)
              })
              if (x.evaluation_method_type_info.evaluation_method_type_name == "现场询问") {
                obj.checkup_object_name = y.checkup_object_info.checkup_object_name
                obj.checkup_object_address = y.checkup_object_info.checkup_object_address
                obj.checkup_object_type_id = y.checkup_object_info.checkup_object_type_info.checkup_object_type_id

              }
              obj.is_positive = y.is_positive
              expert_evaluation_list.push(obj)
            })
          })
          saveCheckupSubjectItemEvaluationInfo({
            checkup_subject_id: this.checkup_subject_id,
            checkup_subject_item_id: this.checkup_subject_item_id,
            checkup_item_deduct_score: this.projectEvelForm.score,
            checkup_item_evaluation_key_issues: this.projectEvelForm.key_issues,
            expert_evaluation_list: [...expert_evaluation_list]
          }).then(res => {
            if (res.data.status == "1") {
              this.$message.success("保存成功")
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    initObjectData() {
      this.objectUploadImages = []
      this.objectUploadFiles = []
      this.modifyObjectIndex = -1
      this.newObjectForm = {
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_item_evaluation_improve_time_limit: '',
        checkup_item_evaluation_inspection_result: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: {
          "checkup_object_name": "",
          "checkup_object_address": "",
          "checkup_object_type_info": {
            "checkup_object_type_id": "",
            "checkup_object_type_name": ""
          }
        },
      }
    },
    addNewObject(value) {
      var datatable = value.expert_evaluation_list
      let expert_evaluation_list = []
      let type = this.checkup_evaluation_project_type_list.find(
        x => x.checkup_evaluation_project_type_id ==
          this.newObjectForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id)
      if (type) {
        this.newObjectForm.checkup_evaluation_project_type_info = type
      }
      type = this.checkup_object_type_list.find(
        x => x.checkup_object_type_id ==
          this.newObjectForm.checkup_object_info.checkup_object_type_info.checkup_object_type_id)
      if (type) {
        this.newObjectForm.checkup_object_info.checkup_object_type_info = {
          checkup_object_type_id: type.checkup_object_type_id,
          checkup_object_type_name: type.checkup_object_type_name
        }
      }
      datatable[this.modifyObjectIndex] = { ...this.newObjectForm }
      var tempID = "";
      if (value.evaluation_method_type_info.evaluation_method_type_id == "2" && this.formInline.checkup_item_inspection_point_content_list.length == 1) {
        tempID = this.formInline.checkup_item_inspection_point_content_list[0].checkup_subject_item_evaluation_origin_id
      } else {
        tempID = this.formInline.checkup_item_inspection_point_content_list[1].checkup_subject_item_evaluation_origin_id
      }
      let obj = {
        "expert_evaluation_id": "0",
        "checkup_subject_item_evaluation_origin_id": tempID,
        "checkup_object_name": "",
        "checkup_object_address": "",
        "checkup_object_type_id": "",
        "checkup_evaluation_project_type_id": "",
        "checkup_evaluation_problem_description": "",
        "checkup_evaluation_improve_suggest": "",
        "checkup_item_evaluation_improve_time_limit": "",
        "checkup_item_evaluation_inspection_result": "",
        "checkup_subject_item_evaluation_image_list": [],
        "checkup_subject_item_evaluation_file_list": [],
        is_positive: 0
      }
      if (this.newObjectForm.expert_evaluation_id != "0") {
        obj.expert_evaluation_id = this.newObjectForm.expert_evaluation_id
      }
      if (this.newObjectForm.checkup_evaluation_project_type_info &&
        this.newObjectForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id &&
        this.newObjectForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id.length > 0) {
        obj.checkup_evaluation_project_type_id = this.newObjectForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id
      }
      obj.checkup_evaluation_problem_description = this.newObjectForm.checkup_evaluation_problem_description ? this.newObjectForm.checkup_evaluation_problem_description : ""
      obj.checkup_evaluation_improve_suggest = this.newObjectForm.checkup_evaluation_improve_suggest ? this.newObjectForm.checkup_evaluation_improve_suggest : ""
      obj.checkup_item_evaluation_improve_time_limit = this.newObjectForm.checkup_item_evaluation_improve_time_limit ? this.newObjectForm.checkup_item_evaluation_improve_time_limit : ""
      obj.checkup_item_evaluation_inspection_result = this.newObjectForm.checkup_item_evaluation_inspection_result ? this.newObjectForm.checkup_item_evaluation_inspection_result : ""
      this.newObjectForm.checkup_subject_item_evaluation_image_list.forEach(z => {
        obj.checkup_subject_item_evaluation_image_list.push(z.path)
      })
      this.newObjectForm.checkup_subject_item_evaluation_file_list.forEach(z => {
        obj.checkup_subject_item_evaluation_file_list.push(z.path)
      })
      obj.checkup_object_name = this.newObjectForm.checkup_object_info.checkup_object_name
      obj.checkup_object_address = this.newObjectForm.checkup_object_info.checkup_object_address
      obj.checkup_object_type_id = this.newObjectForm.checkup_object_info.checkup_object_type_info.checkup_object_type_id
      obj.is_positive = this.newObjectForm.is_positive
      expert_evaluation_list.push(obj)
      saveCheckupSubjectItemEvaluationInfo({
        checkup_subject_id: this.checkup_subject_id,
        checkup_subject_item_id: this.checkup_subject_item_id,
        checkup_item_deduct_score: this.projectEvelForm.score,
        checkup_item_evaluation_key_issues: this.projectEvelForm.key_issues,
        expert_evaluation_list: [...expert_evaluation_list]
      }).then(res => {
        console.log(obj)
        console.log(res)
        if (res.data.status == "1") {
          this.$message.success("保存成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
      datatable = [...datatable]
      this.initObjectData()
    },
    deleteNewObject(datatable) {
      datatable.splice(this.modifyObjectIndex, 1)
      this.initObjectData()
    },
    fileDeleteObjective() {
      this.$nextTick(() => {
        const that = this
        let temp = document.querySelectorAll(".el-upload-list__item .el-icon-close")
        var index = 0;
        var tempArr = [];
        let fileElementList = document.getElementsByClassName('el-upload-list__item-name');
        if (fileElementList && fileElementList.length > 0) {
          for (let ele of fileElementList) {
            let fileName = ele.innerText;
            tempArr.push(fileName)
          }
        }
        for (let element of temp) {
          element.setAttribute('fileName', tempArr[index]);
          element.addEventListener("click", function (e) {
            console.log(that.newObjectForm)
            that.newObjectForm.checkup_subject_item_evaluation_file_list.forEach((item, index) => {
              if (item.file_name == element.getAttribute('fileName')) {
                that.newObjectForm.checkup_subject_item_evaluation_file_list.splice(index, 1);
              }
            });
            that.newObjectForm.checkup_subject_item_evaluation_image_list.forEach((item, index) => {
              if (item.path == element.getAttribute('fileName')) {
                that.newObjectForm.checkup_subject_item_evaluation_image_list.splice(index, 1);
              }
            })
          })
          index = index + 1;
        }
      })
    },
    modifyObject(value, index) {
      while (this.imagList.length != 0) {
        this.imagList.pop();
      }
      while (this.fileList.length != 0) {
        this.fileList.pop();
      }
      while (this.upload_List.length != 0) {
        this.upload_List.pop();
      }
      let datatable = value.expert_evaluation_list
      this.modifyObjectIndex = index
      this.newObjectForm = { ...datatable[index] }
      if (datatable[index].checkup_subject_item_evaluation_file_list.length > 0) {
        var temp = datatable[index].checkup_subject_item_evaluation_file_list
        temp.forEach(element => {
          var tempFile = {
            name: element.file_name,
            percentage: 0,
          }
          this.fileList.push(tempFile);
        });
      }
      if (datatable[index].checkup_subject_item_evaluation_image_list.length > 0) {
        var temp = datatable[index].checkup_subject_item_evaluation_image_list
        temp.forEach(element => {
          var tempFile = {
            name: element.path,
            percentage: 0,
          }
          this.imagList.push(tempFile);
        });
      }
      this.fileDeleteObjective()
    },
    deleteObject(datatable, index) {
      checkItemEvaluationDel({
        expert_evaluation_id: datatable[index].expert_evaluation_id,
      }).then(res => {
        if (res.data.status == "1") {
          this.$message.success("删除成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
      datatable.splice(index, 1)
    },
    objectFileUploadSuccess(res, file, filelist) {

      if (res.status == 0) {
        this.$message.error(res.msg)
        this.$refs.uploadFileRef.clearFiles()
      } else {
        this.newObjectForm.checkup_subject_item_evaluation_file_list.push(
          { ...res.data.file_info })

      }
    },
    objectImageUploadSuccess(res, file, filelist) {

      if (res.status == 0) {
        this.$message.error(res.msg)
        this.$refs.uploadFileRef.clearFiles()
      } else {
        this.newObjectForm.checkup_subject_item_evaluation_image_list.push(
          { ...res.data.image_info })

      }
    },
    addObject(data) {
      while (this.imagList.length != 0) {
        this.imagList.pop();
      }
      while (this.upload_List.length != 0) {
        this.upload_List.pop();
      }
      while (this.fileList.length != 0) {
        this.fileList.pop();
      }
      this.objectUploadImages = []
      this.objectUploadFiles = []
      data.expert_evaluation_list.unshift({
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_item_evaluation_improve_time_limit: '',
        checkup_item_evaluation_inspection_result: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: {
          "checkup_object_name": "",
          "checkup_object_address": "",
          "checkup_object_type_info": {
            "checkup_object_type_id": "",
            "checkup_object_type_name": ""
          }
        },
      })
      this.modifyObjectIndex = 0
    },

    initQuestionData() {
      this.questionUploadImages = []
      this.questionUploadFiles = []
      this.modifyQuestionIndex = -1
      this.newQuestionForm = {
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_item_evaluation_improve_time_limit: '',
        checkup_item_evaluation_inspection_result: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: ''
      }
    },
    addNewQuestion(value) {
      var datatable = value.expert_evaluation_list
      let expert_evaluation_list = []
      let type = this.checkup_evaluation_project_type_list.find(
        x => x.checkup_evaluation_project_type_id ==
          this.newQuestionForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id)
      if (type) {
        this.newQuestionForm.checkup_evaluation_project_type_info = type
      }
      datatable[this.modifyQuestionIndex] = { ...this.newQuestionForm }
      var tempID = "";
      if (value.evaluation_method_type_info.evaluation_method_type_id == "1") {
        tempID = this.formInline.checkup_item_inspection_point_content_list[0].checkup_subject_item_evaluation_origin_id
      } else {
        tempID = this.formInline.checkup_item_inspection_point_content_list[2].checkup_subject_item_evaluation_origin_id
      }
      let obj = {
        "expert_evaluation_id": "0",
        "checkup_subject_item_evaluation_origin_id": tempID,
        "checkup_object_name": "",
        "checkup_object_address": "",
        "checkup_object_type_id": "",
        "checkup_evaluation_project_type_id": "",
        "checkup_evaluation_problem_description": "",
        "checkup_evaluation_improve_suggest": "",
        "checkup_item_evaluation_improve_time_limit": "",
        "checkup_item_evaluation_inspection_result": "",
        "checkup_subject_item_evaluation_image_list": [],
        "checkup_subject_item_evaluation_file_list": [],
        is_positive: 0
      }
      if (this.newQuestionForm.expert_evaluation_id != "0") {
        obj.expert_evaluation_id = this.newQuestionForm.expert_evaluation_id
      }
      if (this.newQuestionForm.checkup_evaluation_project_type_info &&
        this.newQuestionForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id &&
        this.newQuestionForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id.length > 0) {
        obj.checkup_evaluation_project_type_id = this.newQuestionForm.checkup_evaluation_project_type_info.checkup_evaluation_project_type_id
      }
      obj.checkup_evaluation_problem_description = this.newQuestionForm.checkup_evaluation_problem_description ? this.newQuestionForm.checkup_evaluation_problem_description : ""
      obj.checkup_evaluation_improve_suggest = this.newQuestionForm.checkup_evaluation_improve_suggest ? this.newQuestionForm.checkup_evaluation_improve_suggest : ""
      obj.checkup_item_evaluation_improve_time_limit = this.newQuestionForm.checkup_item_evaluation_improve_time_limit ? this.newQuestionForm.checkup_item_evaluation_improve_time_limit : ""
      obj.checkup_item_evaluation_inspection_result = this.newQuestionForm.checkup_item_evaluation_inspection_result ? this.newQuestionForm.checkup_item_evaluation_inspection_result : ""
      this.newQuestionForm.checkup_subject_item_evaluation_image_list.forEach(z => {
        obj.checkup_subject_item_evaluation_image_list.push(z.path)
      })
      this.newQuestionForm.checkup_subject_item_evaluation_file_list.forEach(z => {
        obj.checkup_subject_item_evaluation_file_list.push(z.path)
      })
      obj.is_positive = this.newQuestionForm.is_positive
      expert_evaluation_list.push(obj)
      saveCheckupSubjectItemEvaluationInfo({
        checkup_subject_id: this.checkup_subject_id,
        checkup_subject_item_id: this.checkup_subject_item_id,
        checkup_item_deduct_score: this.projectEvelForm.score,
        checkup_item_evaluation_key_issues: this.projectEvelForm.key_issues,
        expert_evaluation_list: [...expert_evaluation_list]
      }).then(res => {
        if (res.data.status == "1") {
          this.$message.success("保存成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
      datatable = [...datatable]
      this.initQuestionData()
    },
    deleteNewQuestion(datatable) {
      datatable.splice(this.modifyQuestionIndex, 1)
      this.initQuestionData()
    },
    fileDeleteQuestion() {
      this.$nextTick(() => {
        const that = this
        let temp = document.querySelectorAll(".el-upload-list__item .el-icon-close")
        var index = 0;
        var tempArr = [];
        let fileElementList = document.getElementsByClassName('el-upload-list__item-name');
        if (fileElementList && fileElementList.length > 0) {
          for (let ele of fileElementList) {
            let fileName = ele.innerText;
            tempArr.push(fileName)
          }
        }
        for (let element of temp) {
          console.log(element)
          element.setAttribute('fileName', tempArr[index]);
          element.addEventListener("click", function (e) {
            console.log(that.newQuestionForm)
            that.newQuestionForm.checkup_subject_item_evaluation_file_list.forEach((item, index) => {
              if (item.file_name == element.getAttribute('fileName')) {
                that.newQuestionForm.checkup_subject_item_evaluation_file_list.splice(index, 1);
              }
            });
            that.newQuestionForm.checkup_subject_item_evaluation_image_list.forEach((item, index) => {
              if (item.path == element.getAttribute('fileName')) {
                that.newQuestionForm.checkup_subject_item_evaluation_image_list.splice(index, 1);
              }
            })
          })
          index = index + 1;
        }
      })
    },
    modifyQuestion(value, index, type) {
      while (this.imagList.length != 0) {
        this.imagList.pop();
      }
      while (this.fileList.length != 0) {
        this.fileList.pop();
      }
      while (this.upload_List.length != 0) {
        this.upload_List.pop();
      }
      let datatable = value.expert_evaluation_list
      this.modifyQuestionType = type
      this.modifyQuestionIndex = index
      this.newQuestionForm = { ...datatable[index] }
      if (datatable[index].checkup_subject_item_evaluation_file_list.length > 0) {
        var temp = datatable[index].checkup_subject_item_evaluation_file_list
        temp.forEach(element => {
          var tempFile = {
            name: element.file_name,
            percentage: 0,
          }
          this.fileList.push(tempFile);
        });
      }
      if (datatable[index].checkup_subject_item_evaluation_image_list.length > 0) {
        var temp = datatable[index].checkup_subject_item_evaluation_image_list
        temp.forEach(element => {
          var tempFile = {
            name: element.path,
            percentage: 0,
          }
          this.imagList.push(tempFile);
        });
      }
      this.fileDeleteQuestion()
    },
    deleteQuestion(datatable, index) {
      checkItemEvaluationDel({
        expert_evaluation_id: datatable[index].expert_evaluation_id,
      }).then(res => {
        if (res.data.status == "1") {
          this.$message.success("删除成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
      datatable.splice(index, 1)
    },
    questionFileUploadSuccess(res, file, filelist) {

      if (res.status == 0) {
        this.$message.error(res.msg)
        this.$refs.uploadFileRef.clearFiles()
      } else {
        this.newQuestionForm.checkup_subject_item_evaluation_file_list.push(
          { ...res.data.file_info })

      }
    },
    questionImageUploadSuccess(res, file, filelist) {

      if (res.status == 0) {
        this.$message.error(res.msg)
        this.$refs.uploadImageRef.clearFiles()
      } else {
        this.newQuestionForm.checkup_subject_item_evaluation_image_list.push(
          { ...res.data.image_info })
      }
    },
    addQuestion(data, type) {
      while (this.imagList.length != 0) {
        this.imagList.pop();
      }
      while (this.upload_List.length != 0) {
        this.upload_List.pop();
      }
      while (this.fileList.length != 0) {
        this.fileList.pop();
      }
      this.modifyQuestionType = type
      this.questionUploadImages = []
      this.questionUploadFiles = []
      data.expert_evaluation_list.unshift({
        checkup_evaluation_problem_description: '',
        checkup_evaluation_improve_suggest: '',
        checkup_item_evaluation_improve_time_limit: '',
        checkup_item_evaluation_inspection_result: '',
        checkup_subject_item_evaluation_image_list: [],
        checkup_subject_item_evaluation_file_list: [],
        checkup_evaluation_project_type_info: {
          checkup_evaluation_project_type_id: '',
          checkup_evaluation_project_type_name: ''
        },
        expert_evaluation_id: '',
        checkup_object_info: ''
      })
      this.modifyQuestionIndex = 0
    },
    //获取表格与分类
    getTableListInit() {
      getCheckupSubjectItemList({
        checkup_subject_id: this.activeName,
        checkup_item_name: this.form.projectName,
        checkup_category_id: this.form.type[this.form.type.length - 1],
        checkup_item_status_id: this.form.status,
        checkup_status_type: 1

      }).then(res => {
        this.datatable = res.data.data.checkup_subject_item_list

      })
    },
    loadData() {
      getCheckupSubjectList({
        "checkup_project_id": this.checkup_project_id,
        "checkup_status_type": "1"
      }).then(res => {
        this.checkup_subject_list = res.data.data.checkup_subject_list;
        if (this.checkup_subject_list.length > 0) {
          this.activeName = this.checkup_subject_list[0].checkup_subject_id
          getCheckupSubjectItemList({
            checkup_subject_id: this.activeName,
            checkup_status_type: 1

          }).then(res => {
            this.datatable = res.data.data.checkup_subject_item_list

          })
        }

      })

    },
    loadBasicData() {
      getCheckupProjectFileCategoryList().then(res => {
        this.typeOptions = res.data.data.checkup_project_file_category_list
      })
      getCheckupObjectTypeList().then(res => {
        this.checkup_object_type_list = res.data.data.checkup_object_type_list
      })
      getCheckupEvaluationProjectTypeList().then(res => {
        this.checkup_evaluation_project_type_list = res.data.data.checkup_evaluation_project_type_list
      })
      getCheckupCategoryTreeList().then((res) => {
        this.checkup_category_tree_list = res.data.data.checkup_category_tree_list;
      })
        .catch((error) => { });
      this.loadData()
    },
    // 点击"<"返回上一级
    returnPage() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/personEval/GoingProject" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    handleClick(tab, event) {

      getCheckupSubjectItemList({
        checkup_subject_id: this.activeName,
        checkup_status_type: 1

      }).then(res => {
        this.datatable = res.data.data.checkup_subject_item_list

      })
    },
    // 点击详情页的“项目文档”按钮
    showDocDialog() {
      this.dialogVisibleDoc = true;
      getCheckupProjectFileList({
        "checkup_project_id": this.checkup_project_id
      }).then(res => {
        this.projectDocumentData = res.data.data.checkup_project_file_list
      })
    },

    // 点击表格中“评估”按钮--对话框显示
    handleEval(row) {

      this.formInline = row;
      this.dialogVisible = true;
      this.checkup_subject_id = this.activeName
      this.checkup_subject_item_id = row.checkup_subject_item_id
      getCheckupSubjectItemInfo({
        "checkup_subject_id": this.activeName,
        "checkup_subject_item_id": row.checkup_subject_item_id
      }).then(res => {
        this.maxnum = parseInt(res.data.data.checkup_subject_item_info.checkup_item_basic_score)
        this.projectEvelForm.checkup_item_bcadd_bcsub = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_bcadd_bcsub
        console.log(this.projectEvelForm.checkup_item_bcadd_bcsub)
        this.formInline = res.data.data.checkup_subject_item_info
        this.projectEvelForm.score_switch = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_evaluation_deduct_point_switch
        this.projectEvelForm.key_issues_switch = res.data.data.checkup_subject_item_info.checkup_item_evaluation_switch_info.checkup_item_evaluation_key_issues_switch
        this.projectEvelForm.score = parseFloat(res.data.data.checkup_subject_item_info.checkup_item_deduct_score)
        this.projectEvelForm.key_issues = res.data.data.checkup_subject_item_info.checkup_item_evaluation_key_issues
        if (this.projectEvelForm.score_switch == 1 || this.projectEvelForm.key_issues_switch == 1) {
          this.evaluationShow = true;
        }
        if (this.projectEvelForm.checkup_item_bcadd_bcsub == "2") {
          this.scoreFlag = "加分";
        } else {
          this.scoreFlag = "扣分";
        }
        console.log(this.scoreFlag);
      })
    },
    // 点击对话框中"照片"选择
    handleRemoveImg(file, fileList) {

      this.noneBtnImg = fileList.length >= this.limitImg;
    },
    handlePreviewImg(file) {
      this.imageUrl = file.url;
      // this.dialogImgVisible = true;
    },
    handleChangeImg(file, fileList) {
      this.noneBtnImg = fileList.length >= this.limitImg;
    },
    // 点击对话框中“文件”上传-上传按钮隐藏
    handleRemoveFile(file, fileList) {

      this.noneBtnFile = fileList.length >= this.limitFile;
    },
    handlePreviewFile(file) {

    },
    handleChangeFile(file, fileList) {
      this.noneBtnFile = fileList.length >= this.limitFile;
    },
    // 点击“资料评估”中“添加问题”按钮
    addProblem() {
      let item = {
        describe: "",
        classify: "",
        picture: [{ name: '', url: '' }],
        file: [{ name: '', url: '' }],
        propose: ""
      };
      this.materEval.push(item);
    },
    // 点击“现场评估”中“编辑”
    handleEdit(index, row) {
      this.$set(row, 'isShowEdit', true);
    },
    handleEditSuccess(index, row) {
      this.$set(row, 'isShowEdit', false);
    },
    // 点击dialog对话框中的表格中“删除”按钮
    handleDelet(index, rows) {
      rows.splice(index, 1);
    },
    // 项目评估-扣分改变
    handleChange(value) {

    }
  },
  beforeDestroy() {
    eventBus.$off('toProjectEval');
  }
}
</script>
<style scoped>
#goingProDetail {
  position: relative;
}

.header {
  width: 100%;
  height: 35px !important;
  /* border-bottom: 1px solid #ccc; */
}

.header-left {
  width: 200px;
  text-align: left;
  position: absolute;
}

.header-title {
  font-weight: bold;
  /* display: inline-block;
    width: 100px; */
}

.header-right {
  position: absolute;
  right: 20px;
  /* width: 55%; */
  height: 35px;
  top: -15px;
}

.el-form {
  display: flex;
  height: 35px;
}

.el-form-item {
  width: 180px;
  margin-right: 10px;
}

.button {
  height: 38px;
  color: #fff;
  background-color: #000;
}

#goingProDetail>>>.el-input__inner {
  height: 35px;
  padding: 0 10px;
  border: 1px solid #000;
}

#goingProDetail>>>.el-input input::-webkit-input-placeholder {
  color: #9e9fa3;
}

/* 表格样式修改 */
#goingProDetail>>>.el-main {
  padding: 10px 20px;
}

.el-table {
  color: #000;
}

#goingProDetail>>>.el-table thead {
  color: #000;
  font-weight: unset;
}

#goingProDetail>>>.el-table__header {
  width: 100%;

}

#goingProDetail>>>.el-table th.el-table__cell {
  background-color: #f3f3f3;
}

/* #organlist >>> .el-table tr{

} */
#goingProDetail>>>.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: unset;
}

.el-button--text {
  color: #000;
  font-size: 13px;
}

.el-table__row>td {
  border: none;
}

.el-table::before {
  height: 0px;
}

#goingProDetail>>>.el-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid #9e9fa3;
}

/* 对话框样式修改 */
#goingProDetail>>>.el-dialog {
  margin-top: 3vh !important;
  width: 55%;
}

#goingProDetail>>>.docDialog .el-dialog {
  width: 50%;
  margin-top: 20vh !important;
}

#goingProDetail>>>.dialog .el-dialog__header,
#goingProDetail>>>.docDialog .el-dialog__header {
  text-align: left;
  padding: 10px 10px 0px;
}

#goingProDetail>>>.dialog .el-dialog__title,
#goingProDetail>>>.docDialog .el-dialog__title {
  font-size: 16px;
}

#goingProDetail>>>.dialog .el-dialog__body {
  /* padding: 10px 10px; */
  padding: 0px 10px 10px;
  color: #000;
}

#goingProDetail>>>.dialog .el-dialog__body .el-form {
  width: 100%;
  height: 100%;
  display: block;
}

#goingProDetail>>>.dialog .el-dialog__body .el-form p {
  padding: 0px;
  text-align: left;
  font-size: 16px;
}

#goingProDetail>>>.dialog .el-dialog__body .el-form-item {
  width: 31%;
  margin-bottom: unset;
  text-align: left;
}

#goingProDetail>>>.dialog .el-dialog__body .el-form-item.evalContent {
  width: 97%;
}

#goingProDetail>>>.dialog .el-dialog__body .evalContent .el-form-item__content {
  width: 91%;
}

#goingProDetail>>>.dialog .el-form-item__label {
  color: #000;
  font-size: 14px;
  text-align: left;
  line-height: 30px;
}

#goingProDetail>>>.dialog .el-form-item__content {
  line-height: 30px;
  font-size: 14px;
}

/* #goingProDetail >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
} */
#goingProDetail>>>.dialog .el-select {
  width: 100%;
}

#goingProDetail>>>.dialog .el-dialog__footer {
  padding: 0px 10px 10px;
}

.el-icon-arrow-left {
  font-weight: bold;
}

/* 资料评论、现场评估样式 */
.dialog-info .infoTitle p,
.dialog-scene .sceneTitle p,
.dialog-project .sceneTitle p {
  text-align: left;
  font-weight: bold;
  margin-bottom: 5px;
}

.dialog-info .evalMater,
.dialog-scene .sceneMater {
  width: 100%;
  height: 40px;
  border: 1px solid #dfdfdf;
}

.dialog-info .evalMater .evalMater-top,
.dialog-info .evalMater .evalMater-wen,
.dialog-scene .sceneMater .sceneMater-top,
.dialog-scene .sceneMater .sceneMater-wen {
  width: 100%;
  height: 20px;
  text-align: left;
  font-size: 13px;
  line-height: 20px;
  padding-left: 15px;
  box-sizing: border-box;
}

.dialog-info .evalMater .evalMater-top,
.dialog-scene .sceneMater .sceneMater-top {
  background-color: #dfdfdf;
}

/* 修改表格th表头高度 */
#goingProDetail>>>.dialog .el-table__header tr,
#goingProDetail>>>.dialog .el-table__header th {
  padding: 0;
  height: 35px;
  line-height: 35px;
}

/* 修改表格td单元格高度 */
#goingProDetail>>>.dialog .el-table__body tr,
#goingProDetail>>>.dialog .el-table__body td {
  padding: 5px 0px;
  height: 35px;
  line-height: 35px;
}

#goingProDetail>>>.dialog .el-input__inner {
  height: 30px;
  border: 2px solid #ccc;
}

#goingProDetail>>>.dialog .el-table td.el-table__cell,
.dialog .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

/* #goingProDetail >>> .dialog .avatar-uploader .el-upload {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  #goingProDetail >>> .dialog .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
#goingProDetail >>> .dialog .avatar-uploader-icon {
    font-size: 14px;
    color: #8c939d;
    width: 40px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  } */
#goingProDetail>>>.dialog .avatar {
  width: 40px;
  height: 30px;
  display: inline-block;
}

/* 照片上传样式修改 */
#goingProDetail>>>.el-upload--picture-card {
  height: 30px;
  line-height: 30px;
  width: 30px;
  border: 1px solid #c0ccda;
}

.el-upload--picture-card i {
  font-size: 14px;
  color: #000;
}

#goingProDetail>>>.el-upload-list--picture-card .el-upload-list__item {
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin: 0px 5px 0px 0px;
}

#goingProDetail>>>.el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 13px;
}

#goingProDetail>>>.el-upload-list--picture-card .el-upload-list__item-actions span+span {
  margin-left: 0px;
}

#goingProDetail>>>.uploadFile .el-upload--text,
#goingProDetail>>>.uploadImg .el-upload--picture-card {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

#goingProDetail>>>.disUploadFile .el-upload--text,
#goingProDetail>>>.disUploadImg .el-upload.el-upload--picture-card {
  display: none !important;
  /**上传按钮隐藏 */
}

/* 文件上传样式 */
#goingProDetail>>>.dialog .el-upload-list__item:first-child {
  margin-top: unset;
}

#goingProDetail>>>.dialog .el-upload-list__item {
  margin-top: unset;
}

#goingProDetail>>>.el-upload-list__item-name {
  margin-right: 20px;
}

#goingProDetail>>>.dialog .el-divider--horizontal {
  margin: 0px;
}

#goingProDetail>>>.dialog .dialog-project .el-input__inner {
  border: 1px solid #409eff !important;
  color: #000;
}

#goingProDetail>>>.dialog .dialog-project .el-input-number {
  width: 260px;
}

.check-item-evel-info * {
  text-align: left;
}

.jc-check-item-evel-section-header {
  text-align: left;
  border: 2px solid #DFDFDF;
  margin: 5px 0;
}

.jc-check-item-evel-section-header>div:first-child {
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  padding-left: 20px;
  background-color: #DFDFDF;
}

.jc-check-item-evel-section-header>div:last-child {
  line-height: 20px;
  vertical-align: middle;
  padding: 5px 20px;
}

.question-describe-image {
  height: 40px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Expert/GoingProject/GoingProDetail.vue